import type { GetDefaultTabsResponse } from '@risksmart-app/trpc/src/types';
import type {
  GetDefaultTabsQuery,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDefaultTabsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetDefaultTabs = createQueryHook<
  Record<string, never>,
  GetDefaultTabsResponse,
  GetDefaultTabsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.tab.defaults.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    tab: data.tab.map((row) => ({
      ParentType: row.ParentType as Parent_Type_Enum,
      Tabs: row.Tabs,
    })),
    organisation_tab_preference: data.organisation_tab_preference.map(
      (row) => ({
        ObjectType: row.ObjectType as Parent_Type_Enum,
        Preferences: row.Preferences,
      })
    ),
    user_tab_preference: data.user_tab_preference.map((row) => ({
      ObjectType: row.ObjectType as Parent_Type_Enum,
      Preferences: row.Preferences,
    })),
  }),
  graphqlDocument: GetDefaultTabsDocument,
});
